import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'

export const DesignationMasterPopup = (props) => {
    return (
        <ModalBasic
            id="designationMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Designation master</span>
                <div className='item-grp grid grid-cols-1 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Designation</label>
                        <TextInput type='text'
                            id='designation' name='designation'
                            value={props.designationObject.designation}
                            handleChange={(event) => props.handleChange(event, 'designation')}
                            className={props.validState?.error?.designation !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.designationObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}